import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MenuService} from '../services/menu.service';
import {Store} from '@ngrx/store';
import {distinctUntilChanged, map} from 'rxjs/operators';

import {isMenuHidden} from '../store/ui/selectors';
import {toggleMenu} from '../store/ui/actions';
import {getSmshostingIsActive, getUnreadMessages, getUnreadWhatsappMessages} from '../store/account/selectors';
import {getAccountPolling} from "../store/account/actions";

@Component({
  selector: 'app-menu',
  styles: [`
    hr {
      background-color: #4c4e6f;
      height: 2px;
      border: none;
      display: block;
      margin: 5px 0;
    }

  `],
  // host: {
  //     'class' : ''
  // },
  template: `
    <!--begin::Brand-->
    <aside class="aside aside-left aside-fixed d-flex flex-column flex-row-auto"
           [ngClass]="{'aside-on': !isMenuHidden}">
      <div class="brand flex-column-auto" id="kt_brand">
        <!--begin::Logo-->
        <a routerLink="/" class="brand-logo">
          <img alt="Logo" src="/assets/logo-alt.png" height="60"/>
        </a>
        <span class="badge-env badge badge-danger">AREA DI TEST</span>
      </div>
      <!--end::Brand-->
      <!--begin::Aside Menu-->
      <div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
        <!--begin::Menu Container-->
        <div id="kt_aside_menu" class="aside-menu my-4" data-menu-vertical="1" data-menu-scroll="1"
             data-menu-dropdown-timeout="500">
          <!--begin::Menu Nav-->
          <ul class="menu-nav">
            <li routerLinkActive="menu-item-active" [routerLinkActiveOptions]="{exact: true}"
                class="menu-item " aria-haspopup="true">
              <a routerLink="/" class="menu-link">
                <span class="menu-text">Home</span>
              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'riepilogo-attivita'">
              <a routerLink="/dashboard/mantenimenti" class="menu-link">
                <span class="menu-text">Riepilogo attività</span>
              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'calendario'">
              <a routerLink="/dashboard/agenda-appuntamenti" class="menu-link">
                <span class="menu-text">Agenda appuntamenti</span>
              </a>
            </li>

            <li>
              <hr>
            </li>

            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'clienti'">
              <a routerLink="/clienti" class="menu-link">
                <span class="menu-text">Rubrica clienti</span>
              </a>
            </li>
            <!--
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true">
              <a routerLink="/appuntamenti-da-pianificare" class="menu-link">
                <span class="menu-text">Appuntamenti da pianificare</span>
              </a>
            </li>
            -->

            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'messaggistica'">
              <a routerLink="/messaggistica" class="menu-link">
                                <span class="menu-text">
                                    Messaggistica
                                    <span *ngIf="!isSmshostingActive" class="flaticon2-warning text-danger ml-3"></span>
                                </span>

              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'whatsapp'">
              <a routerLink="/whatsapp" class="menu-link">
                <span class="menu-text">WhatsApp</span>
                <span class="menu-label" *ngIf="unreadWhatsappMessages > 0">
                  <span class="label label-rounded label-success">{{ unreadWhatsappMessages }}</span>
                </span>
              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item" aria-haspopup="true" *ngCan="'documenti'">
              <a routerLink="/documenti" class="menu-link">
                <span class="menu-text">Documenti personali</span>
              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true" *ngCan="'preventivi'">
              <a routerLink="/preventivi" class="menu-link">
                <span class="menu-text">Preventivi</span>
              </a>
            </li>
            <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true" *ngCan="'prodotti'">
              <a routerLink="/prodotti" class="menu-link">
                <span class="menu-text">Prodotti</span>
              </a>
            </li>
            <ng-container *ngCan="'magazzino'">
              <li class="menu-section">
                <h4 class="menu-text">Magazzino</h4>
                <i class="menu-icon ki ki-bold-more-hor icon-md"></i>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/magazzino/vendite" class="menu-link">
                  <span class="menu-text">Vendite</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/magazzino/ordini" class="menu-link">
                  <span class="menu-text">Ordini</span>
                </a>
              </li>
            </ng-container>
            <!--
            <li routerLinkActive="menu-item-active" class="menu-item "
                aria-haspopup="true">
              <a routerLink="/servizi" class="menu-link">
                <span class="menu-text">Servizi</span>
              </a>
            </li>
            -->
            <ng-container *ngCanNot="'gestione'">
             <ng-container *ngCan="'faq'">
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/faq" class="menu-link">
                  <span class="menu-text">F.A.Q.</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/risorse" class="menu-link">
                  <span class="menu-text">Risorse</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item "
                  aria-haspopup="true"
                  *ngCan="'assistenza'"
              >
                <a routerLink="/assistenza" class="menu-link">
                  <span class="menu-text">Richieste assistenza</span>
                  <span class="menu-label" *ngIf="unreadMessages > 0">
                                      <span class="label label-rounded label-primary">{{ unreadMessages }}</span>
                                  </span>
                </a>
              </li>

              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/academy-events" class="menu-link">
                  <span class="menu-text">MyAcademy</span>
                </a>
              </li>
             </ng-container>
            </ng-container>
            <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true" *ngCan="'statistiche'">
              <a routerLink="/statistiche" class="menu-link">
                <span class="menu-text">Statistiche</span>
              </a>
            </li>

            <ng-container *ngCan="'gestione'">
              <li class="menu-section">
                <h4 class="menu-text">Gestione portale</h4>
                <i class="menu-icon ki ki-bold-more-hor icon-md"></i>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/faq" class="menu-link">
                  <span class="menu-text">F.A.Q.</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/risorse" class="menu-link">
                  <span class="menu-text">Risorse</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/academy-events" class="menu-link">
                  <span class="menu-text">MyAcademy</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/admin/tipologie-trattamenti" class="menu-link">
                  <span class="menu-text">Tipologie trattamenti</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/admin/utenti" class="menu-link">
                  <span class="menu-text">Operatori</span>
                </a>
              </li>
              <li routerLinkActive="menu-item-active" class="menu-item " aria-haspopup="true">
                <a routerLink="/assistenza" class="menu-link">
                  <span class="menu-text">Richieste assistenza</span>
                  <span class="menu-label" *ngIf="unreadMessages > 0">
                      <span class="label label-rounded label-primary">{{ unreadMessages }}</span>
                  </span>
                </a>
              </li>
            </ng-container>

          </ul>
          <!--end::Menu Nav-->
        </div>
        <!--end::Menu Container-->
      </div>
      <!--end::Aside Menu-->
    </aside>
    <div *ngIf="!isMenuHidden" class="aside-overlay" (click)="this.toggleMenu()"></div>

  `
})

export class MenuComponent implements OnInit, OnDestroy {

  @Input() vertical = true;
  unreadMessages = 0;
  unreadWhatsappMessages = 0;
  isMenuHidden = false;
  isSmshostingActive = null;

  private pollingInterval: any;

  constructor(private menuService: MenuService, private store: Store) {

    this.store.select(getUnreadMessages).subscribe(number => this.unreadMessages = number)
    this.store.select(getUnreadWhatsappMessages).subscribe(number => this.unreadWhatsappMessages = number)
    this.store.select(getSmshostingIsActive).subscribe(value => this.isSmshostingActive = value)
    this.store.select(isMenuHidden)
      .pipe(
        map(value => value),
        distinctUntilChanged()
      ).subscribe(isMenuHidden => {
      this.isMenuHidden = isMenuHidden;
    })

  }

  ngOnInit() {
    this.pollingInterval = setInterval(() => {
      this.store.dispatch(getAccountPolling());
    }, 60 * 1000  * 5 ); // 5 minuti
  }

  ngOnDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  handleClose() {
    this.menuService.hide();
  }

  toggleMenu() {

    this.store.dispatch(toggleMenu({value: !this.isMenuHidden}))

  }

}
